module.exports = __webpack_public_path__ + "img/Weight C.f1b2f4d4.png";